import { render, staticRenderFns } from "./CalendarAsideRates.vue?vue&type=template&id=f70f542e&scoped=true&"
import script from "./CalendarAsideRates.vue?vue&type=script&lang=js&"
export * from "./CalendarAsideRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70f542e",
  null
  
)

export default component.exports